export function isHTMLElement(node) {
  return node.nodeType === Node.ELEMENT_NODE;
}
export function isHTMLAnchorElement(element) {
  return element.nodeName === 'A';
}
export function isHTMLInputElement(element) {
  return element.nodeName === 'INPUT';
}
export function isHTMLButtonElement(element) {
  return element.nodeName === 'BUTTON';
}
export function isHTMLSelectElement(element) {
  return element.nodeName === 'SELECT';
}
export function isHTMLTextAreaElement(element) {
  return element.nodeName === 'TEXTAREA';
}